import { render, staticRenderFns } from "./PrioritySelector.vue?vue&type=template&id=caa62524&"
import script from "./PrioritySelector.vue?vue&type=script&lang=js&"
export * from "./PrioritySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../mobile.zyp.one/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports